
import { mapGetters, mapActions } from "vuex";
import Alert from 'vux/src/components/alert/index.vue'

import api from '../../api/index';
export default {
components: {
Alert
},
props: ['playsinLine', 'preload', 'crfcode', 'baseURL', 'sendUrl', 'typeLimit', 'sizeLimit', 'pageLimit', 'files'],
name: "FrhomoloVideoView",
data() {
return {
fileList: [],
setVideo: {
playsinLine: false,
preload: false
},
showAlert: false,
alertContent: {
title: '',
content: ''
},
showUpload: true
}
},
methods: {
uploadFile(e) {
let file = e.target.files[0];
if (!file.type.startsWith('video/')) {
this.alertContent = {
title: '警告',
content: '请上传视频类型文件'
}
this.showAlert = true;
return;
}
if (this.sizeLimit && file.size / 1024 > this.sizeLimit) {
let largeSize = this.sizeLimit >= 1024 ? parseInt(this.sizeLimit / 1024) + 'M' : this.sizeLimit + 'k';
this.alertContent = {
title: '警告',
content: '请上传' + largeSize + '大小以下文件'
}
this.showAlert = true;
return;
}
if (this.typeLimit) {
let type = file.type.split('/');
let typeLimits = this.typeLimit.split('/');
let flag = false;
typeLimits.forEach(e => {
if (e === type[1]) {
flag = true;
}
})
if (!flag) {
this.alertContent = {
title: '警告',
content: '请上传' + this.typeLimit + '格式文件'
}
this.showAlert = true;
return;
}
}
if (this.sendUrl) {
let baseUrl = this.baseURL || '';
let form = new FormData();
form.set('file', file);
if (this.pageLimit && this.pageLimit >= this.fileList.length + 1) {
this.showUpload = false
}
api.sendVideo(this.crfcode, form, baseUrl, this.sendUrl).then(res =>{
if (res.status === 200 && res.data.success) {
this.fileList.push(res.data);
} else {
this.showUpload = true;
}
}).catch(err => {
this.showUpload = true;
console.log(err);
})
} else {
console.log('请传入上传视频文件接口地址');
}
}
},
watch: {
playsinLine() {
if (this.playsinLine) {
this.setVideo.playsinLine = true;
} else {
this.setVideo.playsinLine = false;
}
},
preload() {
if (this.preload) {
this.setVideo.preload = true;
} else {
this.setVideo.preload = false;
}
}
},
computed: {
},
created() {
if (this.playsinLine) {
this.setVideo.playsinLine = true;
}
if (this.preload) {
this.setVideo.preload = true;
}
if (this.files && this.files.length > 0) {
this.fileList = this.files;
}
},
mounted() {
}
};
